import { User, UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useAddStaffUser = () =>
  useMutationWithLoading(async (params: { user: User; xTENANTID?: string }) =>
    new UserControllerApi(getConfigObject()).addUser(
      params.user,
      params.xTENANTID
    )
  );
